import pageRootFactory from './page-root-factory';

export default pageRootFactory();